import React from 'react'
import { useNavigate } from 'react-router-dom'

const NotFound = () => {
  const navi = useNavigate()
  return (
    <div className="NotFoundPage SubPages">
      <div className="error_page section">
        <div className="content_size">
          <div className="text_center content_wrap">
            <div>{/*<img src={images.error} alt="" />*/}</div>
            <div className="title_text">
              <b>
                죄송합니다.
                <br />
                현재 찾을 수 없는 페이지를 요청하셨습니다.
              </b>
            </div>
            <div className="sub_text font_noto">
              존재하지 않는 주소를 입력하셨거나,
              <br />
              요청하신 페이지의 주소가 변경, 삭제되어 찾을 수 없습니다.
              <br />
              궁금한 점이 있으시면 언제든 고객센터를 통해 문의해 주시기 바랍니다.
              <br />
              감사합니다.
            </div>
            <div className="but_wrap d_ib shadow_st_01">
              <a href="/" className="gradient_light">
                메인으로 가기
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export { NotFound }
